import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { a as useToggletipContext, b as useMergeRefs } from "../../../../chunks/useToggletip-BRp4_0cB.js";
import { c as clsx } from "../../../../chunks/clsx-DgYk2OaC.js";
import "../../../../foundations/icons/IconsDefault.js";
import { Text } from "../../../../foundations/typography/Text/Text.js";
import { ToggletipIcon } from "./ToggletipIcon.js";
import { s as styles } from "../../../../chunks/Toggletip.module-D9Zn2F9e.js";
const ToggletipExplainer = forwardRef(function ToggletipExplainer2({ ariaLabel, showLabel, variant, className }, propRef) {
  const context = useToggletipContext();
  const ref = useMergeRefs([context.refs.setReference, propRef]);
  return /* @__PURE__ */ jsxs(
    "button",
    {
      "aria-label": showLabel ? void 0 : ariaLabel,
      ref,
      className: clsx(
        styles.toggletipExplainer,
        showLabel ? styles.toggletipButton : styles.toggletipTrigger,
        className
      ),
      type: "button",
      ...context.getReferenceProps({
        // Prevent navigation if wrapped in a link
        onClick: (e) => {
          e.preventDefault();
        }
      }),
      children: [
        /* @__PURE__ */ jsx(ToggletipIcon, { isActive: context.open, variant }),
        showLabel && /* @__PURE__ */ jsx(
          Text,
          {
            component: "span",
            variant: "caption",
            className: clsx(styles[`toggletip-${variant}-text`]),
            children: ariaLabel
          }
        )
      ]
    }
  );
});
export {
  ToggletipExplainer
};
